import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as conversation from '../conversation'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: conversation.RESOURCE.payload.dimension.partialId,
      partialId: conversation.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Identifier of the agent handling this conversation.',
    isOptional: false,
    name: 'Conversation Entity',
    partialId: PartialId.Standard.create('conversationEntity'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
